export default "__VITE_ASSET__CLKyzCNB__"